module.exports = __webpack_public_path__ + "static/images/components/BuildingCardImage/images/max-level-50.3d8957d8.png";


//////////////////
// WEBPACK FOOTER
// ./components/BuildingCardImage/images/max-level-50.png
// module id = 2568
// module chunks = 11